import { Component } from "react";

import { OutreachExportFormatType } from "../../enumerations";
import { QESSelect } from "@app/shared/qes-standards";

interface SelectFormatFilterProps {
  testIdPrefix: string; // Used for the testId
  onOutputFormatChange: (exportFormat: OutreachExportFormatType) => void;
  outputFormat: OutreachExportFormatType;
}

export default class SelectFormatFilter extends Component<SelectFormatFilterProps> {
  private readonly outputFormats: Array<{ key: OutreachExportFormatType, value: string }> = [
    { key: OutreachExportFormatType.CSV, value: "Comma-Delimited Text File (.csv)" },
    { key: OutreachExportFormatType.Tab, value: "Tab-Delimited Text File (.txt)" },
    { key: OutreachExportFormatType.Pipe, value: "Bar-Delimited Text File (.txt)" }
  ];

  public render() {
    return (
      <>
        <p className="lead mb0 font-weight-bold">Format Filter</p>
        <div className="form-group row">
          <div className="col-lg-12">
            <QESSelect
              className="mb-0"
              containerClassName="mb-0"
              label="Please select the output format:"
              onChange={(e) => this.props.onOutputFormatChange(e.target.value as OutreachExportFormatType)}
              testId={`outreach-export-${this.props.testIdPrefix}__format-select`}
              value={this.props.outputFormat}
            >
              {
                this.outputFormats.map(({ key, value }) => (
                  <option key={key} value={key}>{value}</option>
                ))}
            </QESSelect>
          </div>
        </div>
      </>
    );
  }
}
